import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormatService {
  private formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  });

  // Calculators only ever deal in whole-rupee estimates, so `currency()` rounding is fine there -
  // but user-entered amounts (an expense, a budget) can be exact paise, and rounding those hides
  // real data (e.g. several sub-rupee imported transactions each show ₹0/₹1 while the total
  // reflects the unrounded sum). This only shows decimals when the value actually has a
  // fractional part, so a plain ₹150 expense still displays as "₹150", not "₹150.00".
  private preciseFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  currency(value: number): string {
    return this.formatter.format(Math.round(value));
  }

  currencyPrecise(value: number): string {
    return this.preciseFormatter.format(value);
  }

  monthName(calendarMonth: number): string {
    const names = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return names[calendarMonth] ?? '';
  }
}
